import { createContext as e } from "react";
const t = {
  viewport: "desktop",
  isMenuOpen: !1,
  lang: "ru",
  apiUrl: "",
  currencies: {}
}, o = e(t);
export {
  o as ThemeContext
};
